export default "__VITE_ASSET__KBexjlQl__"